"use client"

const bannerText =
  "Enjoy 20% Off on Our Exclusive Jewellery Collection – Shop Now Before It's Gone!"

const Separator = () => (
  <span className="mx-8 text-gold opacity-60">✦</span>
)

export default function AnnouncementBanner() {
  return (
    <div className="relative w-full overflow-hidden bg-brown-dark py-2.5 select-none">
      <div className="flex animate-marquee whitespace-nowrap">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="text-xs font-medium tracking-[0.2em] uppercase text-gold-light">
              {bannerText}
            </span>
            <Separator />
          </span>
        ))}
      </div>
    </div>
  )
}
